import { IOption } from 'components/Inputs/SelectComponent/types';

export interface IValidation {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validate: (val: any) => boolean;
  message: string;
}
export const passwordPattern = {
  // value: /((?=.*[A-Z])(?=.*\d).{8,})/g,
  // message: 'Password does not match the safety rule \nAt least: 8 chars long, 1 uppercase and 1 digit',
  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,8}$/,
  message: 'Password does not match requirements',
};
export const emailPattern = {
  value:
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  message: 'Введите правильный Email',
};
export const phonePattern = {
  value: /^[+]?\d{7,15}$/g,
  message: 'Phone not valid',
};
export const urlPattern = {
  // eslint-disable-next-line no-useless-escape
  value: /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gim,
  message: 'The URL you entered is invalid\n(URLs must start with http:// or https://)',
};
export const namePattern = {
  value: /^[\p{L}\p{M}0-9\s'`-]+$/u,
  message: 'Name contains invalid characters',
};

export const urlValidation = (): IValidation => {
  return {
    validate: (val: string) => {
      if (!val) return true;
      try {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const url = new URL(val);
        return true;
      } catch {
        return false;
      }
    },
    message: 'The URL you entered is invalid',
  };
};

export const quantityValidation = (qty: number): IValidation => {
  return {
    validate: (val: IOption[]) => (val?.length || 0) <= qty,
    message: 'Selected to many items',
  };
};
export const DEFAULT_NAME_MIN_LENGTH = 2;
export const minLengthValidation = (min = DEFAULT_NAME_MIN_LENGTH): IValidation => {
  return {
    validate: (val: string) => !val || val.trim().length >= min,
    message: `Minimum ${min} characters`,
  };
};
export const strLengthValidation = (length = 140): IValidation => {
  return {
    validate: (val: string) => (val?.length || 0) <= length,
    message: 'Value is too long',
  };
};
export const moneyInputValidation = (min: number, max: number): IValidation => {
  return {
    validate: (val: string) => {
      if (!val) return true;
      const strToNum = val?.toString().split('.')[0].match(/\d/g)?.join('');
      return !!(strToNum && +strToNum >= min && +strToNum <= max);
    },
    message: `Value must be between ${min} and ${max}`,
  };
};

export const passwordsMatchValidation = (condition: string): IValidation => {
  return {
    validate: (val: string) => val === condition,
    message: 'Passwords does not match',
  };
};

export const integerValidation = (min = 0, max: number): IValidation => {
  return {
    validate: (val: string | number) => {
      if (!val && val !== 0) return true;
      const num = typeof val === 'string' ? parseFloat(val) : val;
      if (isNaN(num)) return false;
      if (!Number.isInteger(num)) return false;
      return num >= min && num <= max;
    },
    message: `Value must be an integer between ${min} and ${max}`,
  };
};
